import { render } from "./HBERC.vue?vue&type=template&id=3a6da705&scoped=true"
import script from "./HBERC.vue?vue&type=script&lang=js"
export * from "./HBERC.vue?vue&type=script&lang=js"

import "./HBERC.vue?vue&type=style&index=0&id=3a6da705&scoped=true&lang=css"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a6da705"]])

export default __exports__